import useFeatureFlags from 'common/hooks/useFeatureFlags';
import useUser from 'common/hooks/useUser';

/**
 * Enables the bootstrap action in the "menu actions" on the classic menu editor. This is intended for the internal team only as a tool to copy over venues in the m2.items into `selections` on the Offering side.
 */
export const useIsBootstrappingToSelectionEnabled = () => {
  const { isEmployee, user } = useUser();

  const {
    data: featureFlags,
    isLoading,
    isFetching,
  } = useFeatureFlags(
    ['enable_vls_bootstrap_action'],
    {
      user_id: user?.id || '',
    },
    { enabled: isEmployee },
  );

  if (!isEmployee || (isLoading && isFetching)) {
    return false;
  }

  return featureFlags?.enable_vls_bootstrap_action === 'on';
};
